import { SVGProps, memo } from 'react'

function RocketSvg({ color, ...rest }: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.9011 1.14746C11.5337 1.46158 10.2728 2.12898 9.24466 3.08286C5.87018 6.20424 5.88232 9.36889 5.88232 9.36889L8.67535 12.1592C8.67535 12.1592 11.8433 12.1713 14.9676 8.80031C15.9228 7.77274 16.591 6.51246 16.9052 5.1457C15.8918 5.0087 14.9514 4.54343 14.2282 3.82123C13.5049 3.09903 13.0387 2.15976 12.9011 1.14746V1.14746ZM11.6144 8.05897C11.292 8.05897 10.9768 7.96345 10.7087 7.7845C10.4406 7.60554 10.2317 7.35118 10.1083 7.05359C9.98492 6.756 9.95263 6.42854 10.0155 6.11261C10.0784 5.79669 10.2337 5.5065 10.4617 5.27873C10.6897 5.05096 10.9802 4.89585 11.2964 4.83301C11.6126 4.77017 11.9404 4.80242 12.2383 4.92569C12.5362 5.04896 12.7908 5.2577 12.9699 5.52553C13.1491 5.79335 13.2447 6.10823 13.2447 6.43034V6.43034C13.2447 6.86228 13.0729 7.27653 12.7672 7.58196C12.4615 7.88738 12.0468 8.05897 11.6144 8.05897V8.05897Z"
        stroke="none"
        strokeMiterlimit="10"
      />
      <path
        d="M16.9052 5.14542C17.248 4.06802 17.3381 2.92628 17.1685 1.80854C17.0935 1.58244 16.9724 1.37437 16.8126 1.19753C16.6247 1.02511 16.4012 0.89601 16.1579 0.819362C15.0618 0.661505 13.9437 0.774052 12.9011 1.14718"
        stroke="none"
        strokeMiterlimit="10"
      />
      <path
        d="M3.29781 11.7779C3.29781 11.7779 2.04549 12.7689 1.96599 15.492C1.96418 15.5641 1.97661 15.6359 2.00257 15.7033C2.02854 15.7706 2.06752 15.8322 2.11731 15.8845C2.1671 15.9368 2.22671 15.9788 2.29274 16.0081C2.35877 16.0374 2.42992 16.0534 2.50214 16.0552C2.50879 16.0553 2.51543 16.0554 2.52207 16.0553C5.15919 16.0062 6.23973 14.7171 6.23973 14.7171C6.61658 14.3204 6.82668 13.7944 6.82668 13.2475C6.82668 12.7006 6.61658 12.1746 6.23973 11.778C5.84515 11.3967 5.3177 11.1836 4.76877 11.1836C4.21984 11.1836 3.6924 11.3967 3.29781 11.7779Z"
        stroke="none"
        strokeMiterlimit="10"
      />
      <path
        d="M12.5815 10.8142C13.756 13.7653 11.9195 16.0266 9.69161 17.1999C9.64913 17.225 9.60193 17.2411 9.55295 17.2472C9.50397 17.2533 9.45426 17.2493 9.40689 17.2354C9.30046 17.2115 9.20782 17.1464 9.14916 17.0545C9.09049 16.9626 9.07056 16.8513 9.0937 16.7448C9.28633 15.8045 9.37229 14.8456 9.34995 13.8862C9.30793 13.2547 9.07238 12.6516 8.67529 12.1585"
        stroke="none"
        strokeMiterlimit="10"
      />
      <path
        d="M7.19015 5.46454C4.23619 4.29123 1.97267 6.12587 0.798197 8.35161C0.773074 8.39406 0.756951 8.44121 0.750829 8.49014C0.744706 8.53907 0.748715 8.58873 0.762607 8.63605C0.786603 8.74238 0.851688 8.83493 0.943681 8.89353C1.03568 8.95214 1.14712 8.97205 1.25375 8.94893C2.19551 8.76065 3.15492 8.67482 4.11518 8.69294C4.75977 8.73111 5.37689 8.96696 5.88241 9.36831"
        stroke="none"
        strokeMiterlimit="10"
      />
    </svg>
  )
}

export default memo(RocketSvg)
